import React from "react";
import { Icon, SecondaryButton } from "@prestosports/commons-ui";
import Download32 from "@carbon/icons-react/lib/download/32";

const TennisExport = ({ boxscore, fileName }) => {
	return (
		<SecondaryButton
			id="button-export-game-data"
			href={URL.createObjectURL(
				new Blob([JSON.stringify(boxscore)], {
					type: "application/json"
				})
			)}
			download={fileName}
			label="Export Game Data"
			startIcon={
				<Icon>
					<Download32 />
				</Icon>
			}
		/>
	);
};

export default TennisExport;
